import { Labels } from '../../shared-components/global/labels';

Labels.set(
    'ui-skip-to-content',
    'linkLabel',
    'Pereiti prie pagrindinio turinio'
);
